export const Check = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={11}
      viewBox="0 0 15 11"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_66_6457)">
        <path
          d="M11.6402 0.765512C11.8603 0.555964 12.1532 0.440117 12.4571 0.442416C12.761 0.444716 13.0521 0.564982 13.269 0.777837C13.4859 0.990692 13.6116 1.27949 13.6197 1.58328C13.6277 1.88708 13.5174 2.18212 13.312 2.40614L7.07767 10.203C6.97047 10.3185 6.84108 10.4111 6.69725 10.4755C6.55342 10.5398 6.39809 10.5744 6.24056 10.5774C6.08303 10.5803 5.92653 10.5514 5.78041 10.4924C5.6343 10.4335 5.50157 10.3457 5.39017 10.2343L1.25579 6.09989C1.14066 5.9926 1.04831 5.86323 0.984262 5.71948C0.920212 5.57573 0.885771 5.42055 0.882995 5.2632C0.880219 5.10586 0.909164 4.94956 0.968103 4.80364C1.02704 4.65772 1.11477 4.52517 1.22605 4.41389C1.33733 4.30261 1.46988 4.21488 1.6158 4.15595C1.76172 4.09701 1.91801 4.06806 2.07536 4.07084C2.23271 4.07361 2.38789 4.10805 2.53164 4.1721C2.67538 4.23615 2.80476 4.3285 2.91204 4.44364L6.18392 7.71395L11.6105 0.799888C11.6203 0.787858 11.6307 0.776381 11.6417 0.765512H11.6402Z"
          fill="#F7941D"
        />
      </g>
      <defs>
        <clipPath id="clip0_66_6457">
          <rect
            width={14}
            height={11}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
